<template>
	<MainLayout>
		<div class="container">
			<div class="box">
				<b-row>
					<b-col md="8">
						<h2>{{$t('settings.title')}}</h2>
					</b-col>

					<b-col md="4" class="text-md-right">
						<b-button variant="primary" @click="updateSettings">{{$t('settings.save')}}</b-button>
					</b-col>
				</b-row>
				<hr>

				<!-- config company -->
				<b-row>
					<b-col lg="7">
						<h4>{{$t('settings.contact')}}</h4>
						<b-row>
							<b-col class="mb-3" lg="12">
								<b-form-group
									:description="$t('settings.legalNameDesc')"
									:label="$t('settings.legalName')"
								>
									<b-form-input type="text" size="sm" v-model="settings.legalName" required />
								</b-form-group>
							</b-col>

							<b-col class="mb-3" lg="12">
								<b-form-group
									:description="$t('settings.websiteDesc')"
									:label="$t('settings.website')"
								>
									<b-form-input type="text" size="sm" v-model="settings.website" required />
								</b-form-group>
							</b-col>

							<b-col class="mb-3" lg="12">
								<b-form-group
									:description="$t('settings.phoneDesc')"
									:label="$t('settings.phone')"
								>
									<b-form-input type="text" size="sm" v-model="settings.contactPhone" required />
								</b-form-group>
							</b-col>

							<b-col class="mb-3" lg="12">
								<b-form-group
									:description="$t('settings.mailDesc')"
									:label="$t('settings.mail')"
								>
									<b-form-input
										type="email"
										size="sm"
										v-model="settings.emailNotifications"
										required
									/>

									<b-input-group
										class="mt-3"
										v-for="(i, index) in emailNotifications"
										:key="index"
									>
										<template #append>
											<b-button
												@click.prevent="
													removeEmailNotifications(
														index
													)
												"
												variant="danger"
												size="sm"
												><md-icon icon="delete"
											/></b-button>
										</template>
										<b-form-input
											:placeholder="$t('settings.title')"
											size="sm"
											v-model="emailNotifications[index]"
											required
										></b-form-input>
									</b-input-group>
								</b-form-group>
								<b-button
									@click.prevent="addEmailNotifications"
									size="sm"
									variant="warning"
									>{{$t('settings.addNewMail')}}</b-button
								>
							</b-col>
						</b-row>
					</b-col>

					<b-col lg="5">
						<div>
							<h4>{{$t('settings.socialMedia')}}</h4>
							<b-form-group
								class="mb-3"
								:description="$t('settings.fbDesc')"
								label="Facebook"
							>
								<b-form-input type="text" size="sm" v-model="settings.facebook" required />
							</b-form-group>

							<b-form-group
								class="mb-3"
								:description="$t('settings.twDesc')"
								label="Twitter"
							>
								<b-form-input type="text" size="sm" v-model="settings.twitter" required />
							</b-form-group>
						</div>
						<div>
							<h4>{{$t('settings.widget')}}</h4>
							<b-form-row>
								<b-col sm="11">
									<b-form-group
									class="mb-3"
									:description="$t('settings.scriptDesc')"
									label="Script"
								>
									<b-form-input type="text" size="sm" readonly :value="beScript" />

									</b-form-group>
								</b-col>
								<b-col sm="1">
										<b-button
											variant="info"
											size="sm"
											class="mt-4"
											@click="copyValue(beScript, true)"
											><md-icon icon="content_copy"
										/></b-button>
								</b-col>
							</b-form-row>
							<b-form-row>
								<b-col sm="11">
									<b-form-group
										class="mb-3"
										:description="$t('settings.tagDesc')"
										:label="$t('settings.tag')"
									>
										<b-form-input type="text" size="sm" readonly :value="beTag" required />
									</b-form-group>
								</b-col>
								<b-col sm="1">
										<b-button
											variant="info"
											size="sm"
											class="mt-4"
											@click="copyValue(beTag)"
											><md-icon icon="content_copy"
										/></b-button>
								</b-col>
							</b-form-row>
						</div>
					</b-col>
				</b-row>
				<!-- /config company -->

			</div>
		</div>
	</MainLayout>
</template>

<script>
import MainLayout from '../layout/MainLayout.vue'
import api from '@/api.js'

export default {
	components: {
		MainLayout,
	},
	data() {
		let defaultSettings = {
			emailNotifications: '',
			contactPhone: '',
			legalName: '',
			facebook: '',
			twitter: '',
			website: '',
		}

		return {
			settings:{...defaultSettings},
			emailNotifications: [],
			pointOfSaleConfig: {}
		}
	},
	computed: {
		beDomain() {
			console.log(this.pointOfSaleConfig)
			return this.pointOfSaleConfig?.domain
		},
		beScript() {
			return `<script src="https://${this.beDomain}/widget-loader.js" be="https://${this.beDomain}"></${''}script>`
		},
		beTag() {
			return `<div id="shuttle-central-booking"></div>`
		}
	},
	methods: {
		getSettingPointOfSale() {
			api(this).get(`point-of-sales/${this.$root.store.state.currentSystem.system.id}`).then(({data}) => {
				this.pointOfSaleConfig = data
			});
		},
		copyValue(value, script) {
			let dummy = document.createElement("textarea");
			document.body.appendChild(dummy);
			dummy.value = value;
			dummy.select();
			document.execCommand("copy");
			document.body.removeChild(dummy);
			if(script) {
				this.$root.showAlert(this.$t('settings.scriptCopy'));
			} else {
				this.$root.showAlert(this.$t('settings.tagCopy'));
			}
		},
		fetchModel(){
			this.loading = true
			this.$root.api.get('setting-vars').then((res) => {
				this.settings = {...res.data.settingVars}

				if(this.settings.emailNotificationsExtra === undefined) {
					this.settings.emailNotificationsExtra = "";
				}

				let emails = this.settings.emailNotificationsExtra.split(",");
				if (emails.length < 1) {
					emails.push("");
				}

				this.emailNotifications = emails;
				this.loading = false
			}).catch(this.$root.handleRequestError);
		},
		addEmailNotifications() {
			// agregar vacio
			this.emailNotifications.push("");
		},
		removeEmailNotifications(index) {
			this.emailNotifications.splice(index, 1);

			// Mantener un input
			if (this.emailNotifications.length < 1) {
				this.emailNotifications.push("");
			}
		},
		validateEmail(email) {
			const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
			return re.test(email);
		},
		updateSettings(){
			let eml = [];
			this.emailNotifications.forEach( (elm) => {
				if (this.validateEmail(elm)) {
					eml.push(elm)
				}
			});

			let settings = {
				emailNotificationsExtra: eml.join(","),
				emailNotifications:		this.settings.emailNotifications,
				contactPhone:			this.settings.contactPhone,
				legalName:				this.settings.legalName,
				website:				this.settings.website,
				facebook:				this.settings.facebook,
				twitter:				this.settings.twitter,
			}

			this.loading = true

			this.$root.api.put('/setting-vars',{ settings }).then(() => {
				this.$root.showAlert(this.$t('global.successUpdate'))
				this.loading = false
				this.fetchModel()
			}).catch(this.$root.handleRequestError);
		}
	},
	mounted() {
		this.getSettingPointOfSale()
		this.fetchModel()
	}
}
</script>
